import { reactive } from 'vue';

import { useToastController } from '@/kernel/controllers/toast-controller';

const state = reactive({
  toasts: {}
});

export const useToastManager = () => {
  const getState = () => {
    return state;
  }
  
  const getToasts = () => {
    return Object.values(state.toasts);
  }
  
  const registerToast = (key, component) => {
    if (!state.toasts[key]) {
      const controller = useToastController();
      state.toasts[key] = {getController: () => controller, getComponent: () => component}
    }
    
    return state.toasts[key].getController();
  }
  
  const unregisterToast = (key) => {
    delete state.toasts[key];
  }
  
  return {
    getState,
    getToasts,
    registerToast,
    unregisterToast
  }
}